import mapboxgl from './mapboxgl';

export const initZoom = (map: mapboxgl.Map) => map.setZoom(17);
